// 004 (FR-028; constitution V; research R5): the web pin map. Leaflet loads only when an address
// form opens (its own chunk). A failed chunk load reports a map error instead of breaking the screen.
import { Component, lazy, type ReactNode, Suspense } from "react";

import type { PinMapProps } from "../types";

const Impl = lazy(() => import("./OsmPinMapImpl.web"));

class MapBoundary extends Component<
  { onError: PinMapProps["onError"]; children: ReactNode },
  { failed: boolean }
> {
  override state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  override componentDidCatch() {
    this.props.onError("timeout");
  }
  override render() {
    return this.state.failed ? null : this.props.children;
  }
}

export function OsmPinMap(props: PinMapProps) {
  return (
    <MapBoundary onError={props.onError}>
      <Suspense fallback={null}>
        <Impl {...props} />
      </Suspense>
    </MapBoundary>
  );
}
